import { render, staticRenderFns } from "./LinkCertificateDialog.vue?vue&type=template&id=cc263da2&scoped=true&"
import script from "./LinkCertificateDialog.vue?vue&type=script&lang=js&"
export * from "./LinkCertificateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc263da2",
  null
  
)

export default component.exports